export const footerStaticItems = {
  company: {
    logo: {
      imgUrl: 'https://onthehub.com/wp-content/uploads/2018/08/kivuto-logo.svg',
      url: 'https://kivuto.com/',
      name: 'Kivuto Logo',
    },
    addressLine1: '7405 RTE TRANSCANADIENNE #100',
    addressLine2: 'SAINT-LAURENT, QC, H4T 1Z2, CA',
    socialIcons: {
      facebook: { name: 'facebook-icon', url: 'https://www.facebook.com/onthehub.network' },
      twitter: { name: 'twitter-icon', url: 'https://twitter.com/onthehub' },
      instagram: { name: 'instagram-icon', url: 'https://www.instagram.com/onthehub/' },
      tiktok: { name: 'tiktok-icon', url: 'https://www.tiktok.com/@onthehub_official' },
    },
  },
}

export const footerPayload = {
  items: [
    {
      isTitle: true,
      title: 'Shop',
      subTitle: [
        {
          isTitle: false,
          title: 'Most Popular',
          url: '/shop?category=most popular',
        },
        {
          isTitle: false,
          title: 'Top Deals',
          url: '/shop?category=top deals',
        },
        {
          isTitle: false,
          title: 'Data Analysis',
          url: '/shop?category=data analysis',
        },
        {
          isTitle: false,
          title: 'Photo, Video & Design',
          url: '/shop?category=photo video design',
        },
        {
          isTitle: false,
          title: 'Security & Utilities',
          url: '/shop?category=security utilities',
        },
        {
          isTitle: false,
          title: 'Business & Office',
          url: '/shop?category=business office',
        },
        {
          isTitle: false,
          title: 'Books',
          url: '/shop?category=books',
        },
      ],
      url: '/shop',
    },
    {
      isTitle: true,
      title: 'Help',
      subTitle: [
        {
          isTitle: false,
          title: 'FAQ',
          url: '/help#faq',
        },
        {
          isTitle: false,
          title: 'Your Account',
          url: '/account',
        },
        {
          isTitle: false,
          title: 'Your Orders',
          url: '/account/order-history',
        },
        {
          isTitle: false,
          title: 'Access Guarantee',
          url: 'https://onthehub.com/search#',
        },
        {
          isTitle: false,
          title: 'Download & Installation',
          url: 'https://onthehub.com/search#',
        },
        {
          isTitle: false,
          title: 'Error Messages',
          url: 'https://onthehub.com/search#',
        },
        {
          isTitle: false,
          title: 'Pricing & Billing',
          url: 'https://onthehub.com/search#',
        },
        {
          isTitle: false,
          title: 'Policies & Security',
          url: 'https://onthehub.com/search#',
        },
      ],
      url: '/help',
    },
    {
      isTitle: true,
      title: 'Contact Us',
      url: '/help#contact-us/support',
    },
    {
      isTitle: true,
      title: 'Sell With Us',
      url: '/sell-with-us',
    },
    {
      isTitle: true,
      title: 'About',
      url: '/about',
    },
  ],
}
